import { configureStore } from '@reduxjs/toolkit';
import appointmentSlice from './slices/appointmentSlice';
import userSlice from './slices/userSlice';
import patientSlice from './slices/patientSlice';
import globalSlice from './slices/globalSlice';
import staffSlice from './slices/staffSlice';

export const store = configureStore({
    reducer: {
        appointments: appointmentSlice,
        user: userSlice,
        patient: patientSlice,
        setting: globalSlice,
        staff: staffSlice,
    },
})